import { useAppContext } from '../contexts/AppContext'
import { processReplacements } from '../utils/processReplacements'

/**
 * Custom hook to process a string with variable replacements.
 * @param srtWithVar The string containing variables to be replaced.
 * @param skipElementTypes An array of element types to skip during processing.
 * @returns The processed string with variables replaced.
 */
function useVars(srtWithVar: string, skipElementTypes: string[] = []) {
  const { elementsWithCode } = useAppContext()
  return processReplacements(srtWithVar, elementsWithCode, true, skipElementTypes) || ''
}

export default useVars
